import { type ContentDataItem } from "~/utils/models";
import { getOccTransport } from "~/common/api/occTransport";

export interface ContentSearchResultsDTO {
  contentData?: ContentDataItem[];
  pagination?: {
    pageSize: number;
    currentPage: number;
    sort: string;
    numberOfPages: number;
    totalNumberOfResults: number;
  };
}

export function fetchContentSearchResults(query: string, page: number = 0): Promise<ContentSearchResultsDTO | false> {
  const { request, url: occUrl } = getOccTransport();
  const params = new URLSearchParams();
  params.set("text", query);
  params.set("page", page.toString());

  const url = occUrl(`/search/searchpage/contentsearch?${params.toString()}`);

  return request(
    url,
    {
      credentials: "same-origin", // include, omit
      mode: "cors", // no-cors, same-origin
      referrer: "no-referrer", // client
    },
    { accountContext: "omit" },
  ).then((response) => {
    if (response.redirected) {
      window.location.reload();
      return false;
    }
    if (response.ok) {
      return response.json();
    }
    return false;
  });
}
